import React from 'react';

// Catches render-time crashes anywhere below it so a single bad message payload
// (or any other thrown error) shows a recoverable screen instead of a white page.
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // Keep a record in the console so it's still debuggable in the field.
    console.error('App crashed (caught by ErrorBoundary):', error, info);
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '16px',
            padding: '24px',
            textAlign: 'center',
            background: '#0f172a',
            color: '#e2e8f0',
            fontFamily: 'system-ui, -apple-system, sans-serif'
          }}
        >
          <div style={{ fontSize: '40px' }}>😵</div>
          <h2 style={{ margin: 0 }}>Something went wrong</h2>
          <p style={{ margin: 0, maxWidth: '320px', color: '#94a3b8' }}>
            The app hit an unexpected error. Reloading usually fixes it.
          </p>
          <button
            onClick={this.handleReload}
            style={{
              marginTop: '8px',
              padding: '12px 24px',
              fontSize: '15px',
              fontWeight: 600,
              color: '#fff',
              background: '#3BA6FF',
              border: 'none',
              borderRadius: '10px',
              cursor: 'pointer'
            }}
          >
            Reload
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
